export interface EncodedData {
    value: string | null;
    name: string;
}

export const color_items: Array<EncodedData> = [
    {
        value: 'D1C4E9',
        name: 'ITEMS.DETAILS.COLOR_PURPLE'
    }, {
        value: 'C5CAE9',
        name: 'ITEMS.DETAILS.COLOR_INDIGO'
    }, {
        value: 'B3E5FC',
        name: 'ITEMS.DETAILS.COLOR_LIGHT_BLUE'
    }, {
        value: 'B2DFDB',
        name: 'ITEMS.DETAILS.COLOR_WATER_GREEN'
    }, {
        value: 'C8E6C9',
        name: 'ITEMS.DETAILS.COLOR_GREEN'
    }, {
        value: 'FFECB3',
        name: 'ITEMS.DETAILS.COLOR_AMBER'
    }, {
        value: 'FFE0B2',
        name: 'ITEMS.DETAILS.COLOR_ORANGE'
    }, {
        value: 'FFCDD2',
        name: 'ITEMS.DETAILS.COLOR_RED'
    }, { 
        value: 'F8D6E0',
        name: 'ITEMS.DETAILS.COLOR_LIGHT_PINK'
    }, {
        value: 'E6D9F0',
        name: 'ITEMS.DETAILS.COLOR_LIGHT_LILAC'
    }, {
        value: 'D8ECD0',
        name: 'ITEMS.DETAILS.COLOR_PISTACHIO_GREEN'
    }, {
        value: 'FFF2C9',
        name: 'ITEMS.DETAILS.COLOR_VANILLA_YELLOW'
    }, {
        value: 'D5EAFB',
        name: 'ITEMS.DETAILS.COLOR_DUSTY_BLUE'
    }, {
        value: 'FFDACC',
        name: 'ITEMS.DETAILS.COLOR_SOFT_PEACH'
    }, {
        value: 'D1F2E7',
        name: 'ITEMS.DETAILS.COLOR_PALE_MINT'
    }, {
        value: 'DFD7EF',
        name: 'ITEMS.DETAILS.COLOR_LAVENDER'
    }, {
        value: 'FFE4C1',
        name: 'ITEMS.DETAILS.COLOR_APRICOT'
    }, {
        value: 'FFCDD2',
        name: 'ITEMS.DETAILS.COLOR_PASTEL_CORAL'
    }, {
        value: 'EDF6FC',
        name: 'ITEMS.DETAILS.COLOR_SNOWY_SKY_BLUE'
    }, {
        value: 'CBE3D6',
        name: 'ITEMS.DETAILS.COLOR_SAGE'
    }
]

export const price_difference_type = [
    {
        value: 'value',
        name: 'ITEMS.DETAILS.PRICE_DIFFERENCE_VALUE'
    }, {
        value: 'perc',
        name: 'ITEMS.DETAILS.PRICE_DIFFERENCE_PERC'
    }
]

export const units = [
    {
        value: 'ITEMS.DETAILS.PIECES_SHORT',
        name: 'ITEMS.DETAILS.PIECES_FULL'
    }, {
        value: 'ITEMS.DETAILS.KILO_METERS_SHORT',
        name: 'ITEMS.DETAILS.METERS_FULL'
    }, {
        value: 'ITEMS.DETAILS.KILO_SHORT',
        name: 'ITEMS.DETAILS.KILO_FULL'
    }, {
        value: 'ITEMS.DETAILS.LITRE_SHORT',
        name: 'ITEMS.DETAILS.LITRE_FULL'
    }
]

export enum exempts {
    'N4' = 'ITEMS.DEPARTMENTS.VAT_EXEMPTION_N4',
    'N1' = 'ITEMS.DEPARTMENTS.VAT_EXEMPTION_N1',
    'N2' = 'ITEMS.DEPARTMENTS.VAT_EXEMPTION_N2',
    'N3' = 'ITEMS.DEPARTMENTS.VAT_EXEMPTION_N3',
    'N5' = 'ITEMS.DEPARTMENTS.VAT_EXEMPTION_N5',
    'N6' = 'ITEMS.DEPARTMENTS.VAT_EXEMPTION_N6',
    'VI' = 'ITEMS.DEPARTMENTS.VAT_EXEMPTION_VI',
}

export const salesTypes = [
    {
        value: 'goods',
        name: 'ITEMS.DEPARTMENTS.SALES_TYPES.GOODS'
    }, {
        value: 'services',
        name: 'ITEMS.DEPARTMENTS.SALES_TYPES.SERVICES'
    }
]

export const vatCodeList = [
    {
        value: '',
        name: 'ITEMS.VAT_RATE.VAT_LIST.NULL'
    },
    {
        value: 'N1',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N1'
    },
    {
        value: 'N2',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N2'
    },
    {
        value: 'N2.1',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N2_1'
    },
    {
        value: 'N2.2',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N2_2'
    },
    {
        value: 'N3',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N3'
    },
    {
        value: 'N3.1',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N3_1'
    },
    {
        value: 'N3.2',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N3_2'
    },
    {
        value: 'N3.3',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N3_3'
    },
    {
        value: 'N3.4',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N3_4'
    },
    {
        value: 'N3.5',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N3_5'
    },
    {
        value: 'N3.6',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N3_6'
    },
    {
        value: 'N4',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N4'
    },
    {
        value: 'N5',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N5'
    },
    {
        value: 'N6',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6'
    },
    {
        value: 'N6.1',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_1'
    },
    {
        value: 'N6.2',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_2'
    },
    {
        value: 'N6.3',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_3'
    },
    {
        value: 'N6.4',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_4'
    },
    {
        value: 'N6.5',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_5'
    },
    {
        value: 'N6.6',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_6'
    },
    {
        value: 'N6.7',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_7'
    },
    {
        value: 'N6.8',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_8'
    },
    {
        value: 'N6.9',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N6_9'
    },
    {
        value: 'N7',
        name: 'ITEMS.VAT_RATE.VAT_LIST.N7'
    }
]